/*
Ashraf 01/11/2023 2699710829 client audit search form
Ashraf 01/12/2023 2699710829 fixed session storage issue
suresh peddavoora 02/21/2023 2699710829 new UI changes for texfields and tables alignments
T Santosh Kumar 15/03/2023 2699710829 Responsive UI Changes
suresh peddavoora 03/30/2023 2699710829 fixed textfields alignments
Akhila 04/19/2023 2699710829  modified client code dropDownData data
*/

import React, {useEffect, useState, useContext} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {
  getBaseCategory,
  resetData,
} from '../../../../../redux/reducers/GlobalField/AddFieldList';
import {Button} from '@material-ui/core';
import {Form, Formik} from 'formik';
import ErrorBoundaryForComponents from '../../../../../util/ErrorBoundaryForComponents';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import FieldListSearchTable from './ClientAuditListSearchTable';
import {WarningSnackbar} from '../../../../../components/CustomSnackBar';
import {getAllReportCreatedForData} from '../../../../../redux/reducers/ReportMaster';
import GuiAutoComplete from '../../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../../components/FormComponents/GuiTextField';
import {getClientCodeData} from '../../../../../redux/reducers/BRE/AddReportMaster';
import {getAllAuditListData} from '../../../../../redux/reducers/GlobalField/ClientAuditList';
import {getClientCodeDropDownData} from '../../../../../redux/reducers/TriggerGroup';
const AddFieldList = ({
  setTabValue,
  setFieldListRowData,
  setUsageState,
  usageState,
  setRowSelected,
  setIsCopyData,
  StepperFieldList,
  setShowSearch,
  setFieldListCode,
  fieldList,
  setFieldList,
  AuditFieldList,
  isLoading,
  deleteSql,
  field,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const [searchData, setSearchData] = useState({fieldListCode: fieldList ? fieldList : ''});
  const {clientCodeDropdownData} = useSelector(({addTriggerGroup}) => addTriggerGroup);
  const [submit, setSubmit] = useState(false);
  const [searchFlag, setSearchFlag] = useState(false);
  const {fieldListDataUsage} = useSelector(({addFieldList}) => addFieldList);
  const [customError, setCustomError] = useState(false);
  const [usage, setUsage] = useState(false);
  const [deleteUsage, setDeleteUsage] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [isUsage, setIsUsage] = useState(false);
  const [userMetrixDelete, setUserMetrixDelete] = useState(false);


  useEffect(() => {
    dispatch(resetData());
    dispatch(getBaseCategory());
    dispatch(getClientCodeData());
    dispatch(getAllAuditListData('AuditField'));
  }, []);

  // checking there is usage or not(2700799562)
  useEffect(() => {
    if (fieldListDataUsage?.userMetrix === 'No') {
      deleteUsage ?
        setUserMetrixDelete(false) :
        isDelete ?
          setCustomError(false) :
          setCustomError(true);
      deleteUsage && setIsDelete(true);
      setTimeout(() => {
        setCustomError(false);
      }, 3000);
    } else if (fieldListDataUsage?.userMetrix === 'Yes') {
      deleteUsage && setIsDelete(true);
      deleteUsage && setUserMetrixDelete(true);
      !isDelete && !deleteUsage && setTabValue(2);
      setUserMetrixDelete(true);
    }
  }, [fieldListDataUsage]);

  // reset state(2700799562)
  useEffect(() => {
    !StepperFieldList && setTabValue(0);
    setIsDelete(false);
    setCustomError(false);
  }, []);
  const SearchSessionFieldList = JSON.parse(sessionStorage.getItem('ClientFieldList'));
  useEffect(() => {
    dispatch(getClientCodeDropDownData());
  }, []);
  // form initialvalues(2700799562)
  const initialValues = {
    fieldListCode: fieldList ? fieldList : '',
    fieldListDescripton: '',
    baseCategory: '',
    createdBy: '',
    createdDate: null,
    clientCode: {},
  };

  // set search Data(2700799562)
  const handleSubmit = (values) => {
    setSearchFlag(true);
    setSearchData(values);
    setSubmit(true);
    if (!StepperFieldList) {
      sessionStorage.setItem('ClientFieldList', JSON.stringify(values));
    }
  };
  useEffect(() => {
    dispatch(getAllReportCreatedForData());
  }, []);
  return (
    // Removed Card styles for text fields (2700799562)
    <div>
      <h2 className="search-title">Client Audit Search</h2>
      <div className={` mb-0`}>
        <Formik
          onSubmit={handleSubmit}
          initialValues={SearchSessionFieldList ? SearchSessionFieldList : initialValues}
          enableReinitialize
          // validationSchema={schema}
        >
          {(props) => {
            const {
              values,
              handleReset,
              setFieldValue,
            } = props;

            return (
              // Changes text field variant from outlined to standard (2700799562)
              <div>
                <Form autoComplete="off">
                  <ErrorBoundaryForComponents>
                    <div className="form-row  standard-field-textfields new-standard-textfields">
                      <div className="col-sm-6 col-xs-6 col-md-4 col-lg-3 form-group">
                        <GuiAutoComplete
                          classes={{
                            option: classes.option,
                            popper: classes.popper,
                          }}
                          name="clientCode"
                          id="clientCode"
                          size="small"
                          value={values.clientCode}
                          options={clientCodeDropdownData?.length > 0 ? clientCodeDropdownData : []}
                          getOptionDisabled={(option) => option?.clientName === ''}
                          getOptionLabel={(option) => {
                            return option && option.clientName ? option.clientName : '';
                          }}
                          onChange={(e, value) => {
                            setFieldValue('clientCode', value);
                          }}
                          placeholder="Select client code"
                          renderInput={(params) => (
                            <div className="select-field">
                              <GuiTextField
                                className={`${classes.labelName}`}
                                {...params}
                                variant="outlined"
                                margin="dense"
                                name="clientCode"
                                label="Client Code"
                                placeholder="Select Client Code"
                              />
                            </div>
                          )}
                        />
                      </div>
                      {/* <div className="col-sm-6 col-md-3 col-lg-2 col-xl-2 form-group">
                                                <GuiAutoComplete
                                                    classes={{
                                                        option: classes.option,
                                                    }}
                                                    name="createdBy"
                                                    id="createdBy"
                                                    size="small"
                                                    value={values.createdBy}
                                                    options={reportCreatedForData}
                                                    getOptionLabel={(option) => {
                                                        return option && option?.userName ? option?.userName : "";
                                                    }}
                                                    onChange={(e, value) => {
                                                        setFieldValue("createdBy", value);
                                                    }}
                                                    renderInput={(params) => (
                                                        <div className="select-field">
                                                            <GuiTextField
                                                                {...params}
                                                                variant="standard"
                                                                margin="dense"
                                                                label="Created By"
                                                                placeholder="Select Created By"
                                                            />
                                                        </div>
                                                    )}
                                                />
                                            </div> */}
                      {/* <div className="col-sm-6 col-md-3 col-lg-2 form-group">
                                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                    <KeyboardDatePicker
                                                        className={` ${classes.labelName}`}
                                                        format="MM/dd/yyyy"
                                                        placeholder="MM/DD/YYYY"
                                                        fullWidth
                                                        value={values.createdDate}
                                                        name="createdDate"
                                                        onBlur={handleBlur}
                                                        inputVariant="standard"
                                                        helperText=""
                                                        label="Created Date"
                                                        onChange={(val) => {
                                                            setFieldValue("createdDate", val);
                                                        }}
                                                        autoOk
                                                        margin="dense"
                                                        touched={touched?.createdDate}
                                                        error={Boolean(touched?.createdDate && errors?.createdDate)}
                                                    />
                                                </MuiPickersUtilsProvider>
                                            </div> */}
                      <div className="col-md-4 col-lg-4 form-group">
                        <div className=" d-flex justify-content-md-end justify-content-lg-start">
                          <Button
                            variant="outlined"
                            className={`mr-1 reset-btn`}
                            onClick={() => {
                              setFieldList && setFieldList('');
                              setSubmit(true);
                              handleReset();
                              setSearchData &&
                                setSearchData({...initialValues, fieldListCode: ''});
                              sessionStorage.removeItem('ClientFieldList');
                            }}
                          >
                            Reset
                          </Button>
                          <Button type="submit" variant="outlined" className={`ml-1 search-btn`}>
                            Search
                          </Button>
                        </div>
                      </div>
                    </div>
                  </ErrorBoundaryForComponents>
                </Form>
              </div>
            );
          }}
        </Formik>

        <FieldListSearchTable
          searchData={searchData}
          setTabValue={setTabValue}
          searchFlag={searchFlag}
          submit={submit}
          setSubmit={setSubmit}
          setUsage={setUsage}
          usage={usage}
          setDeleteUsage={setDeleteUsage}
          setIsDelete={setIsDelete}
          isDelete={isDelete}
          userMetrixDelete={userMetrixDelete}
          setIsUsage={setIsUsage}
          isUsage={isUsage}
          setUserMetrixDelete={setUserMetrixDelete}
          StepperFieldList={StepperFieldList}
          setShowSearch={setShowSearch}
          setFieldListCode={setFieldListCode}
          setFieldList={setFieldList}
          fieldList={fieldList}
          isReportLoader={isLoading}
          deleteSql={deleteSql}
          AuditFieldList={AuditFieldList}
          field={field}
        />
        {customError && (
          <WarningSnackbar errorMsg={'This Audit Field List is not being used anywhere'} />
        )}
      </div>
    </div>
  );
};

export default AddFieldList;
